import { render } from "./ClientReport.vue?vue&type=template&id=66d16d7c&scoped=true"
import script from "./ClientReport.vue?vue&type=script&lang=js"
export * from "./ClientReport.vue?vue&type=script&lang=js"

import "./ClientReport.vue?vue&type=style&index=0&id=66d16d7c&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d16d7c"]])

export default __exports__